import { combineReducers } from 'redux'

import { actionTypeCreator } from './util'

// /////////////////////////////////////////////////////////////////////////////
// Constants
// /////////////////////////////////////////////////////////////////////////////
export const constants = {
  NAME: 'recurrence'
}

// /////////////////////////////////////////////////////////////////////////////
// Action Types
// /////////////////////////////////////////////////////////////////////////////
const createActionType = actionTypeCreator.bind(null, constants.NAME)
export const FETCH = createActionType('FETCH')
export const FETCH_STARTED = createActionType('FETCH_STARTED')
export const FETCH_SUCCESS = createActionType('FETCH_SUCCESS')
export const FETCH_FAILURE = createActionType('FETCH_FAILURE')
export const UPDATE = createActionType('UPDATE')
export const UPDATE_STARTED = createActionType('UPDATE_STARTED')
export const UPDATE_SUCCESS = createActionType('UPDATE_SUCCESS')
export const UPDATE_FAILURE = createActionType('UPDATE_FAILURE')
export const CANCEL = createActionType('CANCEL')
export const CANCEL_STARTED = createActionType('CANCEL_STARTED')
export const CANCEL_SUCCESS = createActionType('CANCEL_SUCCESS')
export const CANCEL_FAILURE = createActionType('CANCEL_FAILURE')
export const FETCH_PENALTY = createActionType('FETCH_PENALTY')
export const FETCH_PENALTY_STARTED = createActionType('FETCH_PENALTY_STARTED')
export const FETCH_PENALTY_SUCCESS = createActionType('FETCH_PENALTY_SUCCESS')
export const FETCH_PENALTY_FAILURE = createActionType('FETCH_PENALTY_FAILURE')

// /////////////////////////////////////////////////////////////////////////////
// Actions
// /////////////////////////////////////////////////////////////////////////////
export function fetch (recurrenceId) {
  return {
    type: FETCH,
    payload: {
      recurrenceId
    }
  }
}

export function update (recurrenceId, props, onComplete = () => {}) {
  return {
    type: UPDATE,
    payload: {
      recurrenceId,
      props
    },
    meta: {
      onComplete
    }
  }
}

export function cancel (recurrenceId, onComplete = () => {}) {
  return {
    type: CANCEL,
    payload: {
      recurrenceId
    },
    meta: {
      onComplete
    }
  }
}

export function fetchUpdatePenalty (recurrenceId, recurrenceChanges) {
  return fetchPenalty({ recurrenceId, recurrenceChanges, method: 'PUT' })
}

export function fetchCancelPenalty (recurrenceId) {
  return fetchPenalty({ recurrenceId, method: 'DELETE' })
}

function fetchPenalty ({ recurrenceId, method, recurrenceChanges }) {
  return {
    type: FETCH_PENALTY,
    payload: {
      recurrenceId,
      recurrenceChanges,
      method
    }
  }
}

// /////////////////////////////////////////////////////////////////////////////
// Queries
// /////////////////////////////////////////////////////////////////////////////
export const isFetching = (state) => state[constants.NAME].fetching
export const isUpdating = (state) => state[constants.NAME].updating
export const isCancelling = (state) => state[constants.NAME].cancelling
export const isFetchingPenalty = state => state[constants.NAME].fetchingPenalty

// /////////////////////////////////////////////////////////////////////////////
// Selectors
// /////////////////////////////////////////////////////////////////////////////
export const getState = (state) => state[constants.NAME]
export const getPenalty = state => getState(state).penalty

// /////////////////////////////////////////////////////////////////////////////
// Reducer
// /////////////////////////////////////////////////////////////////////////////
const initialState = {
  fetching: false,
  updating: false,
  cancelling: false,
  fetchingPenalty: false,
  penalty: null
}

function fetching (state = initialState.fetching, action = {}) {
  switch (action.type) {
    case FETCH_STARTED:
      return true
    case FETCH_SUCCESS:
      return false
    case FETCH_FAILURE:
      return false

    default:
      return state
  }
}

function updating (state = initialState.updating, action = {}) {
  switch (action.type) {
    case UPDATE_STARTED:
      return true
    case UPDATE_SUCCESS:
      return false
    case UPDATE_FAILURE:
      return false

    default:
      return state
  }
}

function cancelling (state = initialState.cancelling, action = {}) {
  switch (action.type) {
    case CANCEL_STARTED:
      return true
    case CANCEL_SUCCESS:
      return false
    case CANCEL_FAILURE:
      return false

    default:
      return state
  }
}

function fetchingPenalty (state = initialState.fetchingPenalty, action = {}) {
  switch (action.type) {
    case FETCH_PENALTY_STARTED:
      return true
    case FETCH_PENALTY_SUCCESS:
      return false
    case FETCH_PENALTY_FAILURE:
      return false

    default:
      return state
  }
}

// I have a feeling that penalty should be it's own module.
function penalty (state = initialState.penalty, action = {}) {
  switch (action.type) {
    case FETCH_PENALTY_STARTED:
      return null // not sure yet this should be null or (the previous) state or what
    case FETCH_PENALTY_SUCCESS:
      return action.payload
    case FETCH_PENALTY_FAILURE:
      return null // not sure yet this should be null or (the previous) state or what

    default:
      return state
  }
}

export const reducer = combineReducers({
  fetching,
  updating,
  cancelling,
  fetchingPenalty,
  penalty
})



// WEBPACK FOOTER //
// ./src/redux/modules/recurrence.js